/* eslint-disable no-unused-expressions */

import React, { PureComponent } from 'react';
import moment from 'moment';
import { Form, Button, Card, Radio, DatePicker, Input, Select, message, InputNumber } from 'antd';
import { patientAppointment, editExamInfo, initHospitalDepts, initExamRoomList, initDeptDoctor, getExamItem, getPatientSourceList } from '@/request/api'
const { Option } = Select;


class Inspect extends PureComponent {
  constructor(props) {
    super(props)
    this.state = {
      // 防止保存按钮重复提交
      apptBtn: true,
      regBtn: true,
      editBtn: true,
      showDisabled: true,   // 表单置灰
      appoDisabled: false,  // 预约置灰
      regDisabled: false,   // 登记置灰
      editDisabled: false,  // 修改置灰
      doctorList: [],       // 申请医生
      examDoctorList: [],   //检查医生列表
      hospitalRoomList: [], // 房间列表
      inspectionType: [],   // 检查类型
      subclassType: [],     // 检查子类
      projectType: [],      // 检查项目
      sourceType: [],       // 患者来源
      dataTime: null,
      params: {
        pageNo: 1,
        pageSize: 10,
        NAME: ""
      }
    }
  }
  componentDidMount() {
    this.getOptionsData()        // 获取三级联动数据
    this.getPatientSourceData()  //获取患者来源列表
    this.initHospitalDept()      // 申请科室
    this.setState({
      showDisabled: false, // 表单可用
      editDisabled: true, // 修改置灰
    })
    //ES6解构赋值
    const { form: { setFieldsValue } } = this.props;
    setFieldsValue({ "CROWD_TYPE": '0' }); //第一次进页面设置Radio的默认选中项为item 1
  }

  componentDidUpdate(prevProps) {
    const { tableData, addType } = this.props // 接收表格传过来的值
    const newTableData = (tableData && tableData[0]) || {}
    const { ACCESSIONNUMBER, ROOM_NO, EXAM_CLASS, EXAM_DOCTOR_UID, REQ_DOCTOR_CODE, REQ_DEPT_CODE, EXAM_DEPT_CODE, ITEM_CODE, EXAM_STATUS, APPOINTMENT_TIME, EXAM_DEPT_NAME, ITEM_NAME, EXAM_NO, BED_NO, EXAM_SUB_CLASS, EXAM_ROOM, REQ_DEPT_NAME, CHARGES, PATIENT_SOURCE, CLIN_DIAG, EXAM_DOCTOR_NAME, CROWD_TYPE, REQ_DOCTOR_NAME } = newTableData
    if (prevProps.tableData !== tableData) {
      this.props.form.setFieldsValue({
        ACCESSIONNUMBER,
        ROOM_NO,
        EXAM_CLASS,
        EXAM_DEPT_NAME,
        EXAM_DEPT_CODE,
        ITEM_NAME,
        ITEM_CODE,
        APPOINTMENT_TIME: APPOINTMENT_TIME && moment(APPOINTMENT_TIME),
        EXAM_NO,
        BED_NO,
        EXAM_SUB_CLASS,
        EXAM_ROOM,
        REQ_DEPT_NAME,
        REQ_DEPT_CODE,
        CHARGES,
        PATIENT_SOURCE,
        CLIN_DIAG,
        EXAM_DOCTOR_NAME,
        CROWD_TYPE,
        REQ_DOCTOR_NAME,
        EXAM_DOCTOR_UID,
        REQ_DOCTOR_CODE
      })
      this.setState({
        dataTime: APPOINTMENT_TIME,
        examDeptCode: EXAM_DEPT_CODE,
        examDeptName: EXAM_DEPT_NAME,
        itemName: ITEM_NAME,
        itemCode: ITEM_CODE,
        deptCode: REQ_DEPT_CODE,
        deptName: REQ_DEPT_NAME,
        doctorCode: REQ_DOCTOR_CODE,
        doctorName: REQ_DOCTOR_NAME,
        examDoctorName: EXAM_DOCTOR_NAME,
        examDoctorCode: EXAM_DOCTOR_UID
      })
    }

    if (prevProps.tableData !== tableData && EXAM_DEPT_CODE !== null) {
      this.initHospitalRoom(EXAM_DEPT_CODE)
      this.initExamDoctor(EXAM_DEPT_CODE)
    }

    if (prevProps.tableData !== tableData && EXAM_CLASS !== null) {
      const { inspectionType } = this.state
      for (let i in inspectionType) {
        if (inspectionType[i].id === EXAM_CLASS) {
          this.setState({
            subclassType: inspectionType[i].child
          })
        }
      }
    }

    if (prevProps.tableData !== tableData && EXAM_STATUS === "-3") {
      this.setState({
        editDisabled: true,  // 修改
        regDisabled: false,  // 登记
        appoDisabled: false, // 预约
      })
    }
    if (prevProps.tableData !== tableData && EXAM_STATUS === "-2") {
      this.setState({
        appoDisabled: true,   // 预约
        editDisabled: false,  // 修改
        regDisabled: false,  // 登记
      })
    }
    if (prevProps.tableData !== tableData && EXAM_STATUS === "-1") {
      this.setState({
        editDisabled: false,  // 修改
        regDisabled: true,    // 登记
        appoDisabled: true,   // 预约
      })
    }
    if (addType === 1) {
      this.setState({
        editDisabled: true,  // 修改
        regDisabled: false,  // 登记
        appoDisabled: false, // 预约
      })
    }
  }

  handleAppointment = async (type) => { // 预约
    const { deptCode, deptName, examDeptCode, dataTime, examDeptName, itemCode, itemName, doctorCode, doctorName, examDoctorCode, examDoctorName } = this.state
    const { tableData, addType, birthdayTime } = this.props
    console.log(addType, 'addType')
    const userInfo = JSON.parse(localStorage.getItem('userInfo')) || {}

    // e.preventDefault();
    // 防止重复提交
    if (this.state.apptBtn) {
      this.setState({
        apptBtn: false
      });

      const that = this;
      this.timerID = setTimeout(function () {
        that.setState({
          apptBtn: true
        });
      }, 2000)

      // 提取PatientData组件的Form数据
      let patientData = await this.props.getPatientData()

      this.props.form.validateFields((err, values) => {
        if (addType === 3) {
          var EXAM_UID = tableData && tableData[0] && tableData[0].EXAM_UID
          var PATIENT_UID = tableData && tableData[0] && tableData[0].PATIENT_UID
        }
        var APPOINTMENT_TIME = tableData && tableData[0] && tableData[0].APPOINTMENT_TIME
        if (!err) {
          let params = {
            Type: type,
            HOSPITAL_CODE: userInfo.HOSPITAL_CODE
          }
          let requestModel = {
            EXAM_UID: EXAM_UID || "",
            PATIENT_UID: PATIENT_UID || "",
            NAME: patientData.NAME,
            BIRTHDAY: birthdayTime,
            OUTP_NO: patientData.OUTP_NO,
            INP_NO: patientData.INP_NO,
            HEIGHT: patientData.HEIGHT,
            CONTACT_TEL: patientData.CONTACT_TEL,
            SEX: patientData.SEX,
            EXAM_AGE: patientData.EXAM_AGE,
            AGE_UNIT: patientData.AGE_UNIT,
            CHARGE_TYPE: patientData.CHARGE_TYPE,
            INSURANCE_TYPE: patientData.INSURANCE_TYPE,
            PATIENT_ID: patientData.PATIENT_ID,
            WEIGHT: patientData.WEIGHT,
            HOME_ADDRESS: patientData.HOME_ADDRESS,
            ACCESSIONNUMBER: values.ACCESSIONNUMBER, // 申请号
            ROOM_NO: values.ROOM_NO, // 房号
            EXAM_CLASS: values.EXAM_CLASS, // 总类（检查类型）

            EXAM_DEPT_CODE: examDeptCode || values.EXAM_DEPT_CODE, // 检查科室
            EXAM_DEPT_NAME: examDeptName || values.EXAM_DEPT_NAME, // 检查科室

            ITEM_NAME: itemName || values.ITEM_NAME, // 检查项目（项目名称）
            ITEM_CODE: itemCode || values.ITEM_CODE, // 检查项目（项目名称）

            EXAM_NO: values.EXAM_NO,// 检查号
            BED_NO: values.BED_NO, // 床号
            EXAM_SUB_CLASS: values.EXAM_SUB_CLASS, // 检查子类
            EXAM_ROOM: values.EXAM_ROOM, // 检查房间

            REQ_DEPT_CODE: deptCode || values.REQ_DEPT_CODE,  // 申请科室
            REQ_DEPT_NAME: deptName || values.REQ_DEPT_NAME, // 申请科室

            REQ_DOCTOR_CODE: doctorCode || values.REQ_DOCTOR_CODE, // 申请医生
            REQ_DOCTOR_NAME: doctorName || values.REQ_DOCTOR_NAME, // 申请医生

            APPOINTMENT_TIME: dataTime || APPOINTMENT_TIME, // 预约检查时间（新建可不需要传）
            PATIENT_SOURCE: values.PATIENT_SOURCE, // 来源
            CLIN_DIAG: values.CLIN_DIAG, // 临床诊断

            EXAM_DOCTOR_NAME: examDoctorName || values.EXAM_DOCTOR_NAME, // 检查医生
            EXAM_DOCTOR_UID: examDoctorCode || values.EXAM_DOCTOR_UID, // 检查医生

            CROWD_TYPE: values.CROWD_TYPE, // 优先级别
            CHARGES: values.CHARGES || 0 // 费用
          }
          patientAppointment(params, requestModel).then((res) => {
            if (res && res.Status === 1) {
              if (type === "APPOINTMENT") {
                message.success("预约成功!")
                // this.props.form.resetFields();
                this.props.clickApptQuery(); // 待预约
              } else {
                message.success("登记成功!")
                this.props.clickAppoQuery(); // 预约
              }
            } else {
              if (type === "APPOINTMENT") {
                message.error("预约失败!")
              } else {
                message.error("登记失败!")
              }
            }
          })
        }
      })
    }
  }

  handleEditInspect = (e) => {  // 修改 
    const { deptCode, deptName, examDeptCode, examDeptName, dataTime, itemCode, itemName, doctorCode, doctorName, examDoctorCode, examDoctorName } = this.state
    const { tableData, addType } = this.props
    console.log(addType, 'addType')
    const userInfo = JSON.parse(localStorage.getItem('userInfo')) || {}
    e.preventDefault();
    // 防止重复提交
    if (this.state.editBtn) {
      this.setState({
        editBtn: false
      });

      const that = this;
      this.timerID = setTimeout(function () {
        that.setState({
          editBtn: true
        });
      }, 2000)
      this.props.form.validateFields((err, values) => {
        if (addType === 3) {
          var EXAM_UID = tableData && tableData[0] && tableData[0].EXAM_UID
          var PATIENT_UID = tableData && tableData[0] && tableData[0].PATIENT_UID
          var EXAM_STATUS = tableData && tableData[0] && tableData[0].EXAM_STATUS
        }
        if (!err) {
          let params = {
            Type: "ExamInfoEDIT",
            HOSPITAL_CODE: userInfo.HOSPITAL_CODE,
          }
          let requestModel = {
            EXAM_UID: EXAM_UID || "",
            PATIENT_UID: PATIENT_UID || "",
            EXAM_STATUS: EXAM_STATUS || "",
            ACCESSIONNUMBER: values.ACCESSIONNUMBER, // 申请号
            ROOM_NO: values.ROOM_NO, // 房号
            EXAM_CLASS: values.EXAM_CLASS, // 总类（检查类型）

            EXAM_DEPT_CODE: examDeptCode, // 检查科室
            EXAM_DEPT_NAME: examDeptName, // 检查科室

            ITEM_NAME: itemName, // 检查项目（项目名称）
            ITEM_CODE: itemCode, // 检查项目（项目名称）

            EXAM_NO: values.EXAM_NO,// 检查号
            BED_NO: values.BED_NO, // 床号
            EXAM_SUB_CLASS: values.EXAM_SUB_CLASS, // 检查子类
            EXAM_ROOM: values.EXAM_ROOM, // 检查房间

            REQ_DEPT_CODE: deptCode,  // 申请科室
            REQ_DEPT_NAME: deptName, // 申请科室

            REQ_DOCTOR_CODE: doctorCode, // 申请医生
            REQ_DOCTOR_NAME: doctorName, // 申请医生

            APPOINTMENT_TIME: dataTime, // 预约检查时间（新建可不需要传）
            PATIENT_SOURCE: values.PATIENT_SOURCE, // 来源
            CLIN_DIAG: values.CLIN_DIAG, // 临床诊断

            EXAM_DOCTOR_NAME: examDoctorName, // 检查医生
            EXAM_DOCTOR_UID: examDoctorCode, // 检查医生

            CROWD_TYPE: values.CROWD_TYPE, // 优先级别
            CHARGES: values.CHARGES || 0 // 费用
          }
          editExamInfo(params, requestModel).then((res) => {
            if (res && res.Status === 1) {
              message.success("修改成功！")
              this.props.clickAppoQuery(); // 预约
              this.props.clickRegQuery();  // 登记
              // this.props.form.resetFields();
            } else {
              message.error("修改失败！")
            }
          })
        }
      })
    }
  }

  initHospitalDept() { // 申请科室
    const userInfo = JSON.parse(localStorage.getItem('userInfo')) || {}
    let params = {
      Type: "Hospital_Dept", //申请科室
      hospital_Code: userInfo.HOSPITAL_CODE,
    }
    initHospitalDepts(params).then((res) => {
      if (res && res.Status === 1) {
        this.setState({
          departmentList: res.Result
        })
      }
    });
  }

  initHospitalRoom(value) { // 检查房间
    const userInfo = JSON.parse(localStorage.getItem('userInfo')) || {}
    let params = {
      Type: "ExamRoomList",
      hospital_uid: userInfo.HOSPITAL_UID,
      DEPT_CODE: value
    }
    initExamRoomList(params).then((res) => {
      if (res && res.Status === 1) {
        this.setState({
          hospitalRoomList: res.Result.ds
        })
      }
    });
  }

  initDoctor(code) { //申请医生
    const userInfo = JSON.parse(localStorage.getItem('userInfo')) || {}
    let params = {
      Type: "Dept_Doctor",
      hospital_Code: userInfo.HOSPITAL_CODE,
      Dept_Code: code
    }
    initDeptDoctor(params).then((res) => {
      if (res && res.Status === 1) {
        const doctor = res.Result
        this.setState({
          doctorList: doctor
        })
      }
    });
  }

  initExamDoctor(item) { // 检查医生
    const userInfo = JSON.parse(localStorage.getItem('userInfo'))
    let params = {
      Type: "Dept_Doctor",
      hospital_Code: userInfo.HOSPITAL_CODE,
      Dept_Code: item
    }
    initDeptDoctor(params).then((res) => {
      if (res && res.Status === 1) {
        const doctor = res.Result
        this.setState({
          examDoctorList: doctor
        })
      }
    });
  }

  // 是否手动清空表单
  changeClearForm = () => {
    //ES6解构赋值
    const { form: { setFieldsValue } } = this.props;
    setFieldsValue({ "CROWD_TYPE": "普通人" }); //第一次进页面设置Radio的默认选中项为item 1
    this.props.form.setFieldsValue({
      ACCESSIONNUMBER: undefined,
      ROOM_NO: undefined,
      EXAM_CLASS: undefined,
      EXAM_DEPT_NAME: undefined,
      ITEM_NAME: undefined,
      APPOINTMENT_TIME: undefined,
      EXAM_NO: undefined,
      BED_NO: undefined,
      EXAM_SUB_CLASS: undefined,
      EXAM_ROOM: undefined,
      REQ_DEPT_NAME: undefined,
      CHARGES: undefined,
      PATIENT_SOURCE: undefined,
      CLIN_DIAG: undefined,
      EXAM_DOCTOR_NAME: undefined,
      REQ_DOCTOR_NAME: undefined,
    });
  }

  handleHospitalDept = (value, option) => { //申请科室
    this.initDoctor(option.props.value)
    this.setState({
      deptCode: option.props.value,
      deptName: option.props.children,
    })
    this.props.form.setFieldsValue({
      REQ_DOCTOR_NAME: undefined,
    });
    this.props.setHospitalDept(option)
  }

  handleExamHospitalDept = (value, option) => { //检查科室
    this.initExamDoctor(option.props.value)
    this.initHospitalRoom(option.props.value)
    this.setState({
      examDeptCode: option.props.value,
      examDeptName: option.props.children,
    })
    this.props.form.setFieldsValue({
      EXAM_DOCTOR_NAME: undefined,
      EXAM_ROOM: undefined,
    });
    this.props.setExamHospitalDept(option)
  }

  // 申请医生
  handleDoctorSelect = (item, option) => {
    this.setState({
      doctorCode: option.props.value,
      doctorName: option.props.children,
    })
    this.props.setDoctor(option)
  }

  // 检查医生
  handleExamDoctorSelect = (item, option) => {
    this.setState({
      examDoctorCode: option.props.value,
      examDoctorName: option.props.children,
    })
    this.props.setExamDoctor(option)
  }

  // 获取患者来源列表
  getPatientSourceData() {
    getPatientSourceList(this.state.params).then(res => {
      if (res && res.Status === 1) {
        this.setState({
          sourceType: res.Result.dataList
        })
      }
    })
  }

  // 获取下拉数据
  getOptionsData = () => {
    let userInfo = JSON.parse(localStorage.getItem("userInfo"));
    if (!userInfo) return;
    let id = userInfo.HOSPITAL_UID;
    getExamItem(id).then((res) => {
      if (res && res.Status === 1) {
        this.setState({
          inspectionType: res.Result
        })
      }
    })
  }

  // 检查类型
  handleInspectionType = (value, option) => {
    const { inspectionType } = this.state
    for (let i in inspectionType) {
      if (inspectionType[i].id === value) {
        this.setState({
          subclassType: inspectionType[i].child
        })
      }
    }
    this.props.form.setFieldsValue({
      EXAM_SUB_CLASS: undefined,
      ITEM_NAME: undefined,
    });
  }

  // 检查子类
  handleSubClassType = (value, option) => {
    const { subclassType } = this.state
    for (let i in subclassType) {
      if (subclassType[i].id === value) {
        this.setState({
          projectType: subclassType[i].child
        })
      }
    }
    this.props.form.setFieldsValue({
      ITEM_NAME: undefined,
    });
  }

  // 检查项目
  handleItem = (item, option) => {
    this.setState({
      itemCode: option.props.value,
      itemName: option.props.children,
    })
    this.props.setInspectItem(option)
  }

  handleRadio = (e) => {
    this.setState({
      radioType: e.target.value
    })
  }

  // 只能选择今天跟今天之后的日期
  disabledDate = (current) => {
    return current < moment().startOf('day');
  }

  onChangeData = (value, dateString) => {
    this.setState({
      dataTime: dateString,
    })
    this.props.setDataTime(dateString)
  }

  render() {
    const { form: { getFieldDecorator } } = this.props;
    const { showDisabled, appoDisabled, regDisabled, hospitalRoomList, examDoctorList, editDisabled, inspectionType, projectType, doctorList, departmentList, subclassType, sourceType } = this.state
    const formItemLayout = {
      labelCol: {
        xs: { span: 24 },
        sm: { span: 8 },
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 16 },
      },
    };
    return (
      <Card size="small" className="followTitle doubleBox bord book2" title={<p>检查信息</p>} >
        <Form {...formItemLayout} ref={this.formRef}>
          <div style={{ float: 'left', width: '33%' }}>
            <Form.Item label="申请号">
              {getFieldDecorator('ACCESSIONNUMBER')(<Input disabled={showDisabled} />)}
            </Form.Item>
            <Form.Item label="房号">
              {getFieldDecorator('ROOM_NO')(<Input disabled={showDisabled} />)}
            </Form.Item>
            <Form.Item label="检查类型">
              {getFieldDecorator('EXAM_CLASS', {
                rules: [{ required: true, message: '请选择检查类型！' }],
              })(
                <Select disabled={showDisabled} placeholder="请选择检查类型" onSelect={this.handleInspectionType}>
                  {
                    inspectionType.map((item) => {
                      return <Option value={item.id} key={item.id}>{item.name}</Option>
                    })
                  }
                </Select>
              )}
            </Form.Item>
            <Form.Item label="检查子类">
              {getFieldDecorator('EXAM_SUB_CLASS', {
                rules: [{ required: true, message: '请选择检查子类！' }],
              })(
                <Select disabled={showDisabled} placeholder="请选择检查子类" onSelect={this.handleSubClassType}>
                  {
                    subclassType.map((item) => {
                      return <Option value={item.id} key={item.id}>{item.name}</Option>
                    })
                  }
                </Select>
              )}
            </Form.Item>
            <Form.Item label="检查项目">
              {getFieldDecorator('ITEM_NAME', {
                rules: [{ required: true, message: '请选择检查项目！' }],
              })(
                <Select disabled={showDisabled} onSelect={this.handleItem} placeholder="请选择检查项目">
                  {
                    projectType.map((item) => {
                      return <Option value={item.id} key={item.id}>{item.name}</Option>
                    })
                  }
                </Select>
              )}
            </Form.Item>
            <Form.Item label="预约时间">
              {getFieldDecorator('APPOINTMENT_TIME', {
                rules: [{ required: true, message: '请选择预约时间！' }],
              })(
                <DatePicker disabled={showDisabled} disabledDate={this.disabledDate} onChange={this.onChangeData} showTime />
              )}
            </Form.Item>
            <Form.Item label="费用">
              {getFieldDecorator('CHARGES', {
              })(<InputNumber min={0} max={1000} precision={2} disabled={showDisabled} />)}
              <span className="ant-form-text">元</span>
            </Form.Item>
            <div style={{ textAlign: 'center', marginTop: '10px' }}>
              <Button onClick={this.changeClearForm}>清空检查信息</Button>
            </div>
          </div>
          <div style={{ float: 'left', width: '33%' }}>
            <Form.Item label="检查号">
              {getFieldDecorator('EXAM_NO')(<Input disabled={showDisabled} />)}
            </Form.Item>
            <Form.Item label="床号">
              {getFieldDecorator('BED_NO')(<Input disabled={showDisabled} />)}
            </Form.Item>
            <Form.Item label="检查科室">
              {getFieldDecorator('EXAM_DEPT_NAME', {
                rules: [{ required: true, message: '请选择检查科室！' }],
              })(
                <Select disabled={showDisabled} onSelect={this.handleExamHospitalDept} placeholder="请选择检查科室">
                  {departmentList && departmentList.map((item) => (
                    <Option key={item.DEPT_CODE} value={item.DEPT_CODE}>
                      {item.DEPT_NAME}
                    </Option>
                  ))}
                </Select>
              )}
            </Form.Item>
            <Form.Item label="检查房间">
              {getFieldDecorator('EXAM_ROOM', {
                rules: [{ required: true, message: '请选择检查房间！' }],
              })(
                <Select allowClear placeholder="请选择检查房间">
                  {hospitalRoomList.map((item) => (
                    <Select.Option key={item.ROOM_NAME} value={item.ROOM_NAME}>
                      {item.ROOM_NAME}
                    </Select.Option>
                  ))}
                </Select>
              )}
            </Form.Item>
            <Form.Item label="申请科室">
              {getFieldDecorator('REQ_DEPT_NAME')(
                <Select disabled={showDisabled} onSelect={this.handleHospitalDept} placeholder="请选择申请科室">
                  {departmentList && departmentList.map((item) => (
                    <Option key={item.DEPT_CODE} value={item.DEPT_CODE}>
                      {item.DEPT_NAME}
                    </Option>
                  ))}
                </Select>
              )}
            </Form.Item>

          </div>
          <div style={{ float: 'left', width: '33%' }}>
            <Form.Item label="来源">
              {getFieldDecorator('PATIENT_SOURCE', {
                rules: [{ required: true, message: '请选择来源！' }],
              })(
                <Select disabled={showDisabled} placeholder="请选择来源">
                  {
                    sourceType.map((item) => {
                      return <Option value={item.PATIENT_SOURCE_CODE} key={item.PATIENT_SOURCE_CODE}>{item.PATIENT_SOURCE_NAME}</Option>
                    })
                  }
                </Select>
              )}
            </Form.Item>
            <Form.Item label="临床诊断">
              {getFieldDecorator('CLIN_DIAG')(<Input disabled={showDisabled} />)}
            </Form.Item>
            <Form.Item label="检查医生">
              {getFieldDecorator('EXAM_DOCTOR_NAME', {
              })(
                <Select disabled={showDisabled} onSelect={this.handleExamDoctorSelect}>
                  {examDoctorList.map(item => (
                    <Option value={item.LOGIN_CODE} key={item.LOGIN_CODE}>{item.REAL_NAME}</Option>
                  ))}
                </Select>
              )}
            </Form.Item>
            <Form.Item label="优先级别">
              {getFieldDecorator('CROWD_TYPE')(
                <Radio.Group disabled={showDisabled}>
                  <Radio value="0">普通人</Radio>
                  <Radio value="1">军人</Radio>
                  <Radio value="2">VIP</Radio>
                </Radio.Group>
              )}
            </Form.Item>
            <Form.Item label="申请医生">
              {getFieldDecorator('REQ_DOCTOR_NAME', {
              })(
                <Select disabled={showDisabled} onSelect={this.handleDoctorSelect}>
                  {doctorList.map(item => (
                    <Option value={item.LOGIN_CODE} key={item.LOGIN_CODE}>{item.REAL_NAME}</Option>
                  ))}
                </Select>
              )}
            </Form.Item>

          </div>
        </Form>

        <div className="bookBtn" style={{ marginTop: '88px' }}>
          <Button type="primary" onClick={() => this.handleAppointment("APPOINTMENT")} disabled={appoDisabled}>预约</Button>
          <Button type="primary" onClick={() => this.handleAppointment("REGISTER")} disabled={regDisabled}>登记</Button>
          <Button type="primary" onClick={this.handleEditInspect} disabled={editDisabled}>保存修改</Button>
          <Button type="primary" onClick={this.handlePrinting}>打印指引单</Button>
        </div>
      </Card >
    )
  }
}

export default Inspect = (Form.create({})(Inspect));
